import { BlueOutlineButton } from "components/components/BlueOutlineButton/BlueOutlineButton";
import { AppliedFilters } from "components/components/Iris/AuthenticatedView/IrisDetailsPage/IrisDetails/QueueInfoCard/QueueFilters/AppliedFilters";
import React, { useState } from "react";

import { QueueFiltersSelector } from "./QueueFiltersSelector";

interface Props {
  queueTitle: string;
  appliedFilters: string[];
  onRemoveAllFiltersClick: () => void;
  fetchIrisDetails: () => void;
}

export const QueueFilters: React.FC<Props> = ({
  queueTitle,
  appliedFilters,
  onRemoveAllFiltersClick,
  fetchIrisDetails,
}) => {
  const hasAppliedFilters = appliedFilters.length > 0;

  const [isSelectorModalActive, setIsSelectorModalActive] = useState(false);

  return (
    <>
      <BlueOutlineButton
        dataTestId="queue-filters-button"
        onClick={(): void => setIsSelectorModalActive(true)}
        buttonText={hasAppliedFilters ? "Edit filters" : "Add filters"}
      />
      <QueueFiltersSelector
        queueTitle={queueTitle}
        appliedFilters={appliedFilters}
        isModalActive={isSelectorModalActive}
        setIsModalActive={setIsSelectorModalActive}
        fetchIrisDetails={fetchIrisDetails}
      />

      {appliedFilters.length > 0 && (
        <AppliedFilters
          appliedFilters={appliedFilters}
          onRemoveAllFiltersClick={onRemoveAllFiltersClick}
        />
      )}
    </>
  );
};
